import type { Config } from "tailwindcss";
import defaultTheme from "tailwindcss/defaultTheme.js";

export default {
	darkMode: "class",
	theme: {
		extend: {
			fontFamily: {
				sans: ["montserrat", ...defaultTheme.fontFamily.sans],
				montserrat: ["montserrat"],
				oswald: ["oswald"],
			},
			fontSize: {
				xs: ["0.75rem", "1.25"],
				sm: ["0.9rem", "1.25"],
				base: ["1rem", "1.25"],
				md: ["2rem", "1.25"],
				lg: ["3rem", "1.25"],
				xl: ["4rem", "1.25"],
			},
			colors: {
				primary: {
					DEFAULT: "#D5177F",
					hover: "#FF219B",
				},
				secondary: {
					DEFAULT: "#F8D327",
					50: "#FFF1B3",
				},
				light: {
					100: "#F4F5F5",
					200: "#EFEEEE",
					300: "#DBDADA",
				},
				grey: {
					200: "#8C8D8D",
					300: "#7F8080",
					400: "#727373",
					500: "#656666",
					600: "#595858",
					700: "#4C4B4B",
					800: "#3F3E3E",
					900: "#323131",
				},
			},
		},
	},
} satisfies Partial<Config>;
